 const equipment = [
  {
    icon: "Pickaxe",
    name: "Excavator 21.5 Ton",
    category: "Excavation",
    specs: "Includes Spare Bucket | Hydraulic System | Heavy Duty",
    available: 1,
  },
  {
    icon: "Hammer",
    name: "Breaker Attachment",
    category: "Demolition",
    specs: "Compatible with 20-30 Ton Excavators | High Impact Force",
    available: 2,
  },
  {
    icon: "Drill",
    name: "Welding Machine",
    category: "Fabrication",
    specs: "300 AMP | Portable | Ideal for onsite repair work",
    available: 2,
  },
  {
    icon: "Wrench",
    name: "Air Compressor",
    category: "Workshop Equipment",
    specs: "250 Litre | 5 HP | Dual Output | High Pressure",
    available: 1,
  },
  {
    icon: "Zap",
    name: "Diesel Generator Set",
    category: "Power Supply",
    specs: "15–125 kVA | Soundproof | Fuel Efficient",
    available: 3,
  },
  {
    icon: "Truck",
    name: "Tipping Truck",
    category: "Transport",
    specs: "16 Cubic Meter | Ideal for Sand & Gravel Hauling",
    available: 2,
  },
  {
    icon: "Cog",
    name: "Plate Compactor",
    category: "Road Work",
    specs: "90 kg | Honda Engine | Ideal for surface compaction",
    available: 3,
  },
  {
    icon: "HardHat",
    name: "Safety Gear Kit",
    category: "Safety",
    specs: "Helmet | Gloves | Shoes | Reflective Vest",
    available: 10,
  },
  {
    icon: "Shield",
    name: "Cutting Machine",
    category: "Workshop Tools",
    specs: "14 Inch Blade | Heavy Duty | Steel/Metal Cutting",
    available: 4,
  },
  {
    icon: "Wrench",
    name: "Hydraulic Jack",
    category: "Garage Tools",
    specs: "20 Ton Capacity | Portable | Industrial Grade",
    available: 2,
  },
];

export default equipment;